import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import OnboardingWizard from "./components/OnboardingWizard";
import Materiales from "./pages/Materiales";
import Entradas from "./pages/Entradas";
import Salidas from "./pages/Salidas";
import Navbar from "./components/Navbar";
import Movimientos from "./pages/Movimientos";
import EntradaFactura from "./pages/EntradaFactura";
import DashboardInventario from "./pages/DashboardInventario";
import Categorias from "./pages/Categorias";
import Login from "./pages/Login";
import api from "./services/api";
import Usuarios from "./pages/Usuarios";
import Reportes from './pages/Reportes';
import InventarioFisico from './pages/InventarioFisico';
import ComparacionInventario from './pages/ComparacionInventario';
import EntradasPendientes from "./pages/EntradasPendientes";
import EntradasHistorial from "./pages/EntradasHistorial";
import RequisicionesPendientes from "./pages/RequisicionesPendientes";
import CrearRequisicion from "./pages/CrearRequisicion";
import DashboardRequisiciones from "./pages/DashboardRequisiciones";
import DepartamentoDashboard from "./pages/DepartamentoDashboard";
import Departamentos from './pages/Departamentos';
import POS from "./pages/POS";
import Clientes from "./pages/Clientes";
import Ventas from "./pages/Ventas";
import ReportesPOS from "./pages/ReportesPOS";
import GestionCajas from "./pages/GestionCajas";
import HistorialCajas from "./pages/HistorialCajas";
import GestionCajasFisicas from "./pages/GestionCajasFisicas";
import ConfiguracionNCF from "./pages/ConfiguracionNCF";
import DashboardCaja from "./pages/DashboardCaja";
import GestionCajasAdmin from "./pages/GestionCajasAdmin";
import DashboardRencar from "./rencar/DashboardRencar";
import Vehiculos from "./rencar/Vehiculos";
import RentaCrear from "./rencar/RentaCrear";
import InspeccionSalida from "./rencar/InspeccionSalida";
import InspeccionEntrada from "./rencar/InspeccionEntrada";
import RentasAbiertas from "./rencar/RentasAbiertas";
import ReportesRencar from "./rencar/ReportesRencar";
import Proyectos from "./pages/Proyectos";
import CrearProyecto from "./pages/CrearProyecto";
import EditarProyecto from "./pages/EditarProyecto";
import DetalleProyecto from "./components/Detalleproyecto";
import Almacenes from "./components/Almacenes";
import StockAlmacen from "./components/StockAlmacen";
import Transferencias from "./components/Transferencias";
import Prestamos from "./components/Prestamos";
import Salidalote from "./pages/Salidalote";
import DashboardFinanciero from './components/DashboardFinanciero';
 import Facturas from "./pages/Facturas";
 import NuevaFactura from "./pages/NuevaFactura";
 import DetalleFactura from "./pages/DetalleFactura";
 import DashboardCuentasPorCobrar from "./pages/DashboardCuentasPorCobrar";
 import EditarFactura from "./pages/EditarFactura";
 import ReportesFacturacion from "./pages/ReportesFacturacion";
 import CategoriasPartida from './pages/CategoriasPartida';
 import PartidasEstandar from './pages/PartidasEstandar';
 import Certificaciones from './pages/Certificaciones';
import CrearCertificacion from './pages/CrearCertificacion';
import CertificacionesGlobal from './pages/CertificacionesGlobal';
import DetalleCertificacion from './pages/DetalleCertificacion';
import AuditoriaDashboard from "./pages/AuditoriaDashboard";
import ConfiguracionAuditoriaExterna from './pages/ConfiguracionAuditoriaExterna';
import Prospectos from './pages/CRM/Prospectos'
import Pipeline from './pages/CRM/Pipeline';
import ProspectoDetalle from "./components/CRM/ProspectoDetalle";
import DetalleCotizacion from './components/CRM/DetalleCotizacion';
import DashboardCRM from './components/CRM/DashboardCRM';
import CotizacionRapida from './components/Cotizaciones/CotizacionRapida';
import CotizacionesList from './components/Cotizaciones/CotizacionesList';
import OportunidadesList from './components/CRM/OportunidadesList';
import LandingPro from "./pages/Landing/LandingPro";
import ConfirmarEmail from "./pages/ConfirmarEmail";





// 🔥 NUEVOS IMPORTS - MÓDULO POS Y CONFIGURACIÓN
import Dashboard from "./pages/Dashboard";
import Configuracion from "./pages/Configuracion";
import SuperAdminPanel from "./pages/SuperAdminPanel";
// 📒 MÓDULOS CONTABLES Y NÓMINA
import Contabilidad from "./pages/Contabilidad";
import CuentasPagar from "./pages/CuentasPagar";
import ReportesDGII from "./pages/ReportesDGII";
import NotasCreditoDebito from "./pages/NotasCreditoDebito";
import Bancos from "./pages/Bancos";
import Empleados from "./pages/Empleados";
import NominaUniversal from "./pages/NominaUniversal";
import ReporteTSS from "./pages/ReporteTSS";
import ActivosFijos from "./pages/ActivosFijos";
import EmpresasContables from "./pages/EmpresasContables";
import Migracion from "./pages/Migracion";
import ManualUsuario from "./pages/ManualUsuario";
import MiSuscripcion from "./pages/MiSuscripcion";
import EcfConfiguracion from "./pages/EcfConfiguracion";
import EmailDashboard from "./components/email/EmailDashboard";
import EmailCampaignList from "./components/email/EmailCampaignList";
import EmailCampaignCreate from "./components/email/EmailCampaignCreate";
import EmailCampaignDetail from "./components/email/EmailCampaignDetail";
import EmailTemplateList from "./components/email/EmailTemplateList";
import EmailTemplateCreate from "./components/email/EmailTemplateCreate";
import EmailTemplateEdit from "./components/email/EmailTemplateEdit";
import EmailGrupoList from "./components/email/EmailGrupoList";
import EmailGrupoCreate from "./components/email/EmailGrupoCreate";
import EmailGrupoMembers from "./components/email/EmailGrupoMembers";
import OrdenesCompra from "./pages/OrdenesCompra";
import Proveedores from "./pages/Proveedores";
import TrialBanner, { TrialVencidoScreen, EmpresaInactivaScreen } from "./components/TrialBanner";
// import POS from "./pages/POS"; // Pendiente crear
// import Clientes from "./pages/Clientes"; // Pendiente crear
// import Ventas from "./pages/Ventas"; // Pendiente crear

function App() {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [mostrarOnboarding, setMostrarOnboarding] = useState(false);
  const [bannerEmpresa, setBannerEmpresa] = useState(false);
  const [diasTrial, setDiasTrial] = useState(null); // null = no trial, número = días restantes

  // Escuchar logout disparado desde el interceptor de Axios
  useEffect(() => {
    const handler = () => setUsuario(null);
    window.addEventListener("efit:logout", handler);
    return () => window.removeEventListener("efit:logout", handler);
  }, []);

  // Verificar si hay sesión activa al cargar
  useEffect(() => {
    const token = localStorage.getItem("token");
    const usuarioGuardado = localStorage.getItem("usuario");

    if (token && usuarioGuardado) {
      try {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        setUsuario(JSON.parse(usuarioGuardado));
        // Verificar si el tenant ya tiene país configurado
        verificarOnboarding();
      } catch (error) {
        console.error("Error al cargar sesión:", error);
        localStorage.removeItem("token");
        localStorage.removeItem("usuario");
      }
    }
    setCargando(false);
  }, []);

  const verificarOnboarding = async () => {
    try {
      const r = await api.get('/configuracion');
      // Mostrar wizard si el tenant no tiene país asignado
      if (!r.data.pais_codigo || r.data.pais_codigo === null) {
        setMostrarOnboarding(true);
      }
      // Banner de trial si quedan <= 7 días
      if (r.data.es_trial && typeof r.data.dias_trial_restantes === 'number') {
        if (r.data.dias_trial_restantes <= 7) {
          setDiasTrial(r.data.dias_trial_restantes);
        }
      }
    } catch { /* silencioso — no bloquear el app */ }

    // Verificar empresa contable para roles que la necesitan
    const ROLES_CON_EMPRESA = ['superadmin', 'admin', 'supervisor'];
    const usuarioActual = JSON.parse(localStorage.getItem('usuario') || 'null');
    if (usuarioActual && ROLES_CON_EMPRESA.includes(usuarioActual.rol) && !localStorage.getItem('empresa_contable_id')) {
      try {
        const empRes = await api.get('/empresas-contables');
        const lista = empRes.data.empresas || empRes.data;
        const activas = Array.isArray(lista) ? lista.filter(e => e.activa) : [];
        if (activas.length === 1 && !activas[0].tiene_pin) {
          // Auto-seleccionar solo si la única empresa NO tiene PIN configurado
          localStorage.setItem('empresa_contable_id', activas[0].id);
          localStorage.setItem('empresa_contable_nombre', activas[0].nombre);
        } else if (activas.length === 0) {
          setBannerEmpresa(true);
        }
        // Si hay > 1 o tiene PIN → el usuario selecciona en EmpresasContables
      } catch { /* silencioso */ }
    }
  };

  const handleLogin = (usuarioData) => {
    setUsuario(usuarioData);
    // Verificar onboarding después del login
    setTimeout(verificarOnboarding, 600);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    localStorage.removeItem("empresa_contable_id");
    localStorage.removeItem("empresa_contable_nombre");
    delete api.defaults.headers.common["Authorization"];
    setUsuario(null);
  };

  if (cargando) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '18px',
        fontWeight: '600'
      }}>
        🔄 Cargando...
      </div>
    );
  }

  // Componente para proteger rutas según rol
  const RutaProtegida = ({ children, rolesPermitidos }) => {
    if (!usuario) {
      return <Navigate to="/login" replace />;
    }

    // Si es visualizador y no está en sus rutas permitidas
    if (usuario.rol === "visualizador" && !rolesPermitidos.includes("visualizador")) {
      return <Navigate to="/departamento/dashboard" replace />;
    }

    // Si NO tiene el rol permitido
    if (!rolesPermitidos.includes(usuario.rol)) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

  // Pantalla de bloqueo si la empresa está inactiva
  const mensajeInactiva = localStorage.getItem('empresa_inactiva');
  if (mensajeInactiva && usuario) {
    return <EmpresaInactivaScreen mensaje={mensajeInactiva} />;
  }

  // Pantalla de bloqueo si el trial venció
  const mensajeTrialVencido = localStorage.getItem('trial_vencido');
  if (mensajeTrialVencido && usuario) {
    return <TrialVencidoScreen mensaje={mensajeTrialVencido} />;
  }

  return (
    <HelmetProvider>
    <Router>
      {/* Wizard de onboarding — primer login sin país configurado */}
      {usuario && mostrarOnboarding && (
        <OnboardingWizard onComplete={() => setMostrarOnboarding(false)} />
      )}

     {!usuario ? (
  <Routes>
    <Route path="/"                        element={<LandingPro />} />
    <Route path="/login"                   element={<Login onLogin={handleLogin} />} />
    <Route path="/confirmar-email/:token"  element={<ConfirmarEmail />} />
    <Route path="*"                        element={<Navigate to="/" replace />} />
  </Routes>
) : (
        <>
          <Navbar usuario={usuario} onLogout={handleLogout} />
          {/* Banner de trial cuando quedan 7 días o menos */}
          {diasTrial !== null && <TrialBanner dias={diasTrial} />}

          {/* Banner: empresa contable no configurada */}
          {bannerEmpresa && ['superadmin', 'admin', 'supervisor'].includes(usuario.rol) && (
            <div style={{
              background: '#fef3c7', borderBottom: '2px solid #f59e0b',
              padding: '10px 24px', display: 'flex', alignItems: 'center',
              gap: 12, fontSize: 13, color: '#92400e', fontWeight: 500,
            }}>
              <span>⚠️ No tienes una empresa contable configurada. Algunas funciones estarán limitadas.</span>
              <a href="/configuracion" style={{ color: '#b45309', fontWeight: 700, textDecoration: 'underline', whiteSpace: 'nowrap' }}>
                Ir a Configuración →
              </a>
              <button
                onClick={() => setBannerEmpresa(false)}
                style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: '#92400e', fontSize: 20, lineHeight: 1 }}
              >×</button>
            </div>
          )}

          <Routes>
            {/* Ruta pública accesible incluso con sesión activa */}
            <Route path="/confirmar-email/:token" element={<ConfirmarEmail />} />

            {/* 🔥 NUEVO: DASHBOARD PRINCIPAL CON MÓDULOS DINÁMICOS */}
           <Route 
  path="/dashboard" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor", "almacenero", "cajero", "supervisor_pos", "contador", "auxiliar_contable", "supervisor_contable"]}>
      <Dashboard />
    </RutaProtegida>
  } 
/>

          {/* 🔥 CONFIGURACIÓN (Solo Super Admin) */}
<Route
  path="/configuracion"
  element={
    <RutaProtegida rolesPermitidos={["superadmin"]}>
      <Configuracion />
    </RutaProtegida>
  }
/>
<Route
  path="/mi-suscripcion"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <MiSuscripcion />
    </RutaProtegida>
  }
/>
<Route
  path="/dashboard-caja"
  element={<RutaProtegida rolesPermitidos={["admin", "superadmin"]}>
    <DashboardCaja />
  </RutaProtegida>}
/>

            {/* DASHBOARD INVENTARIO - Mantener por compatibilidad */}
            <Route 
              path="/" 
              element={
                usuario.rol === "visualizador" ? (
                  <Navigate to="/departamento/dashboard" replace />
                ) : (
                  <Navigate to="/dashboard" replace />
                )
              } 
            />

            {/* DASHBOARD DEPARTAMENTO - Solo visualizador y admin */}
            <Route 
              path="/departamento/dashboard" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin", "visualizador", "admin"]}>
                  <DepartamentoDashboard />
                </RutaProtegida>
              } 
            />

            {/* CREAR REQUISICIÓN - visualizador y admin */}
            <Route 
              path="/crear-requisicion" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","visualizador", "admin"]}>
                  <CrearRequisicion />
                </RutaProtegida>
              } 
            />

            {/* ========================================== */}
            {/* RUTAS MÓDULO OFICINA (Inventario)         */}
            {/* ========================================== */}

            <Route 
              path="/materiales" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor", "supervisor_pos"]}>
                  <Materiales />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/entradas" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor"]}>
                  <Entradas />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/salidas" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor"]}>
                  <Salidas />
                </RutaProtegida>
              } 
            />
            <Route 
  path="/salidas/lote" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor"]}>
      <Salidalote />
    </RutaProtegida>
  } 
/>

            <Route 
              path="/movimientos" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor"]}>
                  <Movimientos />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/entrada-factura" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "almacenero"]}>
                  <EntradaFactura />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/categorias" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero"]}>
                  <Categorias />
                </RutaProtegida>
              } 
            />

          <Route 
  path="/usuarios" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <Usuarios />
    </RutaProtegida>
  } 
/>

            <Route 
              path="/reportes" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor"]}>
                  <Reportes />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/inventario/fisico" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor"]}>
                  <InventarioFisico />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/inventario/comparacion" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor"]}>
                  <ComparacionInventario />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/entradas-pendientes" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor"]}>
                  <EntradasPendientes />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/entradas-historial" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "almacenero"]}>
                  <EntradasHistorial />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/requisiciones" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor"]}>
                  <RequisicionesPendientes />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/departamentos" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin"]}>
                  <Departamentos />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/dashboard-requisiciones" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "almacenero", "supervisor"]}>
                  <DashboardRequisiciones />
                </RutaProtegida>
              } 
            />

            {/* ⭐ NUEVO: PROYECTOS ⭐ */}
<Route 
  path="/proyectos"
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor"]}>
      <Proyectos />
    </RutaProtegida>
  }
/>

<Route
  path="/almacenes"
  element={
    <RutaProtegida rolesPermitidos={["admin", "superadmin", "supervisor", "almacenero"]}>
      <Almacenes />
    </RutaProtegida>
  }
/>

<Route
  path="/almacenes/:id/stock"
  element={
    <RutaProtegida rolesPermitidos={["admin", "superadmin", "supervisor", "almacenero"]}>
      <StockAlmacen />
    </RutaProtegida>
  }
/>

<Route 
  path="/proyectos/nuevo"
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor"]}>
      <CrearProyecto />
    </RutaProtegida>
  }
/>

<Route 
  path="/proyectos/editar/:id"
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor"]}>
      <EditarProyecto />
    </RutaProtegida>
  }
/>
<Route 
  path="/proyectos/:id"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor", "usuario"]}>
      <DetalleProyecto />
    </RutaProtegida>
  }
/>
<Route
  path="/transferencias"
  element={
    <RutaProtegida rolesPermitidos={["admin", "superadmin", "supervisor", "almacenero"]}>
      <Transferencias />
    </RutaProtegida>
  }
/>
<Route
  path="/prestamos"
  element={
    <RutaProtegida rolesPermitidos={["admin", "superadmin", "supervisor"]}>
      <Prestamos />
    </RutaProtegida>
  }
/>
<Route 
  path="/proyectos/:proyectoId/finanzas" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor"]}>
      <DashboardFinanciero />
    </RutaProtegida>
  } 
/>
<Route 
  path="/categorias-partida" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <CategoriasPartida />
    </RutaProtegida>
  } 
/>

<Route 
  path="/partidas-estandar" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <PartidasEstandar />
    </RutaProtegida>
  } 
/>

<Route 
  path="/certificaciones" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "empleado"]}>
      <CertificacionesGlobal />
    </RutaProtegida>
  } 
/>
<Route 
  path="/proyectos/:proyectoId/certificaciones" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "empleado"]}>
      <Certificaciones />
    </RutaProtegida>
  } 
/>
<Route 
  path="/proyectos/:proyectoId/certificaciones/nueva" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "empleado"]}>
      <CrearCertificacion />
    </RutaProtegida>
  } 
/>

<Route 
  path="/certificaciones/:id" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "empleado"]}>
      <DetalleCertificacion />
    </RutaProtegida>
  } 
/>
{/* RUTAS MÓDULO FACTURACIÓN */}
   <Route
     path="/facturas"
     element={
       <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor", "contador", "auxiliar_contable", "supervisor_contable"]}>
         <Facturas />
       </RutaProtegida>
     }
   />
   <Route
  path="/facturas/nueva"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor", "contador", "auxiliar_contable"]}>
      <NuevaFactura />
    </RutaProtegida>
  }
/>

<Route
  path="/facturas/:id"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor", "contador", "auxiliar_contable", "supervisor_contable"]}>
      <DetalleFactura />
    </RutaProtegida>
  }
/>
<Route
  path="/facturas/:id/editar"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "contador"]}>
      <EditarFactura />
    </RutaProtegida>
  }
/>
<Route
  path="/facturas/reportes"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor", "contador", "auxiliar_contable", "supervisor_contable"]}>
      <ReportesFacturacion />
    </RutaProtegida>
  }
/>
<Route
  path="/facturas/dashboard"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor", "contador", "auxiliar_contable", "supervisor_contable"]}>
      <DashboardCuentasPorCobrar />
    </RutaProtegida>
  }
/>

            {/* ========================================== */}
            {/* RUTAS MÓDULO POS (Punto de Venta)         */}
            {/* ========================================== */}

            
            <Route 
              path="/pos" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "cajero", "supervisor_pos"]}>
                  <POS />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/clientes" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "cajero", "supervisor_pos", "contador", "auxiliar_contable", "supervisor_contable"]}>
                  <Clientes />
                </RutaProtegida>
              } 
            />

            <Route 
              path="/ventas" 
              element={
                <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "cajero", "supervisor_pos"]}>
                  <Ventas />
                </RutaProtegida>
              } 
            />

            <Route 
  path="/reportes-pos" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "supervisor_pos"]}>
      <ReportesPOS />
    </RutaProtegida>
  } 
/>
<Route 
  path="/gestion-cajas" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "cajero", "supervisor_pos"]}>
      <GestionCajas />
    </RutaProtegida>
  } 
/>

<Route 
  path="/cajas-fisicas" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "supervisor_pos"]}>
      <GestionCajasFisicas />
    </RutaProtegida>
  } 
/>
<Route 
  path="/gestion-cajas-admin" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "supervisor"]}>
      <GestionCajasAdmin />
    </RutaProtegida>
  } 
/>

<Route 
  path="/historial-cajas" 
  element={
    <RutaProtegida rolesPermitidos={["superadmin","admin", "supervisor", "supervisor_pos"]}>
      <HistorialCajas />
    </RutaProtegida>
  } 
/>
<Route
  path="/configuracion-ncf"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin", "contador"]}>
      <ConfiguracionNCF />
    </RutaProtegida>
  }
/>
<Route
  path="/configuracion/ecf"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <EcfConfiguracion />
    </RutaProtegida>
  }
/>


             {/* ========================================== */}
            {/* RUTAS MÓDULO Rencar (Punto de Venta)         */}
            {/* ========================================== */}



{/* Dashboard RenCar */}
<Route
  path="/rencar"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <DashboardRencar />
    </RutaProtegida>
  }
/>

{/* Vehículos */}
<Route
  path="/rencar/vehiculos"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <Vehiculos />
    </RutaProtegida>
  }
/>

{/* Crear Renta */}
<Route
  path="/rencar/rentas/crear"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <RentaCrear />
    </RutaProtegida>
  }
/>

{/* Inspección de salida */}
<Route
  path="/rencar/inspeccion-salida/:id"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <InspeccionSalida />
    </RutaProtegida>
  }
/>

{/* Inspección de entrada */}
<Route
  path="/rencar/inspeccion-entrada/:id"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <InspeccionEntrada />
    </RutaProtegida>
  }
/>

<Route
  path="/rencar/rentas-abiertas"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <RentasAbiertas />
    </RutaProtegida>
  }
/>

<Route
  path="/rencar/reportes"
  element={
    <RutaProtegida rolesPermitidos={["superadmin", "admin"]}>
      <ReportesRencar />
    </RutaProtegida>
  }
/>



 {/* ========================================== */}
 {/*AUDITORIA DE SISTEMA        */}
 {/* ========================================== */}

<Route
  path="/admin/auditoria"
  element={
    <RutaProtegida rolesPermitidos={["superadmin"]}>
      <AuditoriaDashboard />
    </RutaProtegida>
  }
/>

   <Route 
          path="/configuracion/auditoria-externa" 
          element={
            <RutaProtegida rolesPermitidos={["superadmin"]}>
              <ConfiguracionAuditoriaExterna />
            </RutaProtegida>
          } 
        />
 {/* ========================================== */}
{/* RUTAS MÓDULO CRM - COMERCIAL */}
{/* ========================================== */}

<Route
  path="/crm/dashboard"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <DashboardCRM />
    </RutaProtegida>
  }
/>
<Route
  path="/crm/prospectos"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <Prospectos />
    </RutaProtegida>
  }
/>
<Route
  path="/crm/pipeline"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <Pipeline />
    </RutaProtegida>
  }
/>
<Route
  path="/crm/prospectos/:id"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <ProspectoDetalle />
    </RutaProtegida>
  }
/>

<Route
  path="/crm/cotizaciones/:id"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <DetalleCotizacion />
    </RutaProtegida>
  }
/>

<Route 
  path="/crm/oportunidades"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <OportunidadesList />
    </RutaProtegida>
  }
/>
 {/* ═══════════════════════════════════════════════════════════════════════ */}
{/* MÓDULO DE COTIZACIONES */}
{/* ═══════════════════════════════════════════════════════════════════════ */}

{/* Lista de cotizaciones */}
<Route
  path="/cotizaciones"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <CotizacionesList />
    </RutaProtegida>
  }
/>

{/* Nueva cotización */}
<Route
  path="/cotizaciones/nueva"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <CotizacionRapida />
    </RutaProtegida>
  }
/>

<Route
  path="/cotizaciones/editar/:id"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <CotizacionRapida />
    </RutaProtegida>
  }
/>
<Route
  path="/cotizaciones/:id"
  element={
    <RutaProtegida rolesPermitidos={['superadmin', 'admin', 'supervisor_comercial', 'vendedor']}>
      <DetalleCotizacion />
    </RutaProtegida>
  }
/>



 {/* ========================================== */}
{/* PANEL SUPER ADMIN GLOBAL */}
{/* ========================================== */}
<Route
  path="/superadmin"
  element={
    <RutaProtegida rolesPermitidos={['superadmin']}>
      <SuperAdminPanel />
    </RutaProtegida>
  }
/>

 {/* ========================================== */}
{/* MÓDULOS CONTABLES, NÓMINA, BANCOS */}
{/* ========================================== */}
<Route path="/contabilidad" element={<RutaProtegida rolesPermitidos={["superadmin","admin","contador","supervisor_contable"]}><Contabilidad /></RutaProtegida>} />
<Route path="/cuentas-pagar" element={<RutaProtegida rolesPermitidos={["superadmin","admin","supervisor","contador","supervisor_contable"]}><CuentasPagar /></RutaProtegida>} />
<Route path="/dgii/reportes" element={<RutaProtegida rolesPermitidos={["superadmin","admin","supervisor","contador","supervisor_contable"]}><ReportesDGII /></RutaProtegida>} />
<Route path="/notas" element={<RutaProtegida rolesPermitidos={["superadmin","admin","supervisor","contador","auxiliar_contable"]}><NotasCreditoDebito /></RutaProtegida>} />
<Route path="/ordenes-compra" element={<RutaProtegida rolesPermitidos={["superadmin","admin","supervisor","almacenero","contador","auxiliar_contable"]}><OrdenesCompra /></RutaProtegida>} />
<Route path="/proveedores" element={<RutaProtegida rolesPermitidos={["superadmin","admin","contador","supervisor_contable"]}><Proveedores /></RutaProtegida>} />
<Route path="/bancos" element={<RutaProtegida rolesPermitidos={["superadmin","admin","supervisor","contador","supervisor_contable"]}><Bancos /></RutaProtegida>} />
<Route path="/empleados" element={<RutaProtegida rolesPermitidos={["superadmin","admin","supervisor","contador","supervisor_contable"]}><Empleados /></RutaProtegida>} />
<Route path="/nomina" element={<RutaProtegida rolesPermitidos={["superadmin","admin","contador","supervisor_contable"]}><NominaUniversal /></RutaProtegida>} />
<Route path="/nomina/reporte-tss" element={<RutaProtegida rolesPermitidos={["superadmin","admin","contador","supervisor_contable"]}><ReporteTSS /></RutaProtegida>} />
<Route path="/activos-fijos" element={<RutaProtegida rolesPermitidos={["superadmin","admin","contador","supervisor_contable"]}><ActivosFijos /></RutaProtegida>} />
<Route path="/empresas-contables" element={<RutaProtegida rolesPermitidos={["superadmin","admin","contador"]}><EmpresasContables /></RutaProtegida>} />
<Route path="/migracion" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><Migracion /></RutaProtegida>} />
<Route path="/manual" element={<RutaProtegida rolesPermitidos={["superadmin","admin","supervisor","almacenero","cajero","contador","auxiliar_contable","supervisor_contable"]}><ManualUsuario /></RutaProtegida>} />

 {/* ========================================== */}
{/* MÓDULO EMAIL MARKETING */}
{/* ========================================== */}
<Route path="/email" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailDashboard /></RutaProtegida>} />
<Route path="/email/campanas" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailCampaignList /></RutaProtegida>} />
<Route path="/email/campanas/nueva" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailCampaignCreate /></RutaProtegida>} />
<Route path="/email/campanas/:id" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailCampaignDetail /></RutaProtegida>} />
<Route path="/email/plantillas" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailTemplateList /></RutaProtegida>} />
<Route path="/email/plantillas/nueva" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailTemplateCreate /></RutaProtegida>} />
<Route path="/email/plantillas/editar/:id" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailTemplateEdit /></RutaProtegida>} />
<Route path="/email/grupos" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailGrupoList /></RutaProtegida>} />
<Route path="/email/grupos/nuevo" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailGrupoCreate /></RutaProtegida>} />
<Route path="/email/grupos/:id/miembros" element={<RutaProtegida rolesPermitidos={["superadmin","admin"]}><EmailGrupoMembers /></RutaProtegida>} />

 {/* ========================================== */}
{/* RUTA POR DEFECTO */}
{/* ========================================== */}
           
            <Route 
              path="*" 
              element={
                usuario.rol === "visualizador" ? (
                  <Navigate to="/departamento/dashboard" replace />
                ) : (
                  <Navigate to="/dashboard" replace />
                )
              } 
            />
          </Routes>
        </>
      )}
    </Router>
    </HelmetProvider>
  );
}

export default App;